module.exports = __webpack_public_path__ + "media/images/moscow-1cb03480fedb467f888296d9bc09e8e7.jpg";